// i18nOwl-ignore [app-discord.triggerIntegrations.has-role.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import DiscordHasRoleTriggerIntegrationConfigComponent from '@cohort/merchants/apps/discord/triggerIntegrations/hasRole/ConfigComponent';
import DiscordHasRoleTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/discord/triggerIntegrations/hasRole/StepCompletionTitleComponent';
import type {DiscordHasRoleTriggerStruct} from '@cohort/shared/schema/apps/discord/triggers/hasRole';
import {DiscordHasRoleTriggerIntegrationSpec} from '@cohort/shared/schema/apps/discord/triggers/hasRole';

export const DiscordHasRoleTriggerIntegration: TriggerIntegration<DiscordHasRoleTriggerStruct> = {
  spec: DiscordHasRoleTriggerIntegrationSpec,
  configComponent: DiscordHasRoleTriggerIntegrationConfigComponent,
  stepCompletionTitleComponent: DiscordHasRoleTriggerIntegrationStepCompletionTitleComponent,
};
